<template>
  <div class="integral">
    <!-- 提意见蒙版 -->
    <el-dialog
      title="提建议"
      :visible.sync="shouldUploadSuggestionShow"
      width="530px"
      top="0vh"
      class="uploadSuggestion"
      :close-on-click-modal="false"
      :before-close="hideSugMask"
    >
      <!-- <div v-if="shouldUploadSuggestionShow" class="uploadSuggestion"> -->
      <div class="sugArea" style="margin-left: -20px; margin-bottom: -30px;">
        <!-- <div class="sugTitle">
          <h3>提建议</h3>
          <div @click="hideSugMask" class="cancelIcon"></div>
        </div> -->
        <!-- <ul v-if="sugTypeList" class="sugTypeChoose">
          <li
            v-for="(item, index) in sugTypeList"
            :key="index"
            :class="item.title === activeSugTitle ? 'activeSug' : ''"
            @click="changeActiveSugTypeList(item.title)"
          >
            {{item.title}}
          </li>
        </ul> -->
        <textarea
          v-model.trim="sugContent"
          class="sugContent"
          placeholder="请写下您的建议..."
          style="margin-top: 20px;"
        >
        <p style="height: 215px;"></p>
        </textarea>
        <div style="flex: 1"></div>
        <div class="sugButton">
          <div @click="hideSugMask" class="sugCancel">
            取 消
          </div>
          <div @click="uploadSug" class="sugConfirm">
            提 交
          </div>
        </div>
      </div>
      <!-- </div> -->
    </el-dialog>
    <!-- 提意见蒙版结束 -->
    <div class="integralArea">
      <div class="integralBreadcrumb">
        <div @click="jumpToMy">个人中心</div>
        <div class="el-icon-arrow-right"></div>
        <div>积分管理</div>
      </div>
      <ul class="integralNav" v-if="userIntegralInfo">
        <li @click="$router.push({ name: 'integralGetList' })" class="wdjf">
          <p>积分详情</p>
          <div class="wdjf1">{{ userIntegralInfo.userPoint }}</div>
          <div class="wdjf2">
            最近积分变动 <span v-if="userIntegralInfo.getIntegral > 0">+</span
            >{{ userIntegralInfo.getIntegral }}
          </div>
        </li>
        <li @click="$router.push({ name: 'integralOrder' })" class="wdjfdd">
          <p>积分订单</p>
          <div class="wdjfdd1">{{ userIntegralInfo.userUsedPoint }}</div>
          <div class="wdjfdd2">
            <div class="wdjfdd21">
              待发货：{{ userIntegralInfo.toBeShipped }}
            </div>
            <div class="wdjfdd22">已发货：{{ userIntegralInfo.shipped }}</div>
          </div>
        </li>
        <li @click="$router.push({ name: 'integralExchange' })" class="jfdh">
          <p>积分兑换</p>
          <div class="jfdh1">{{ userIntegralInfo.availableIntegral }}</div>
          <div class="jfdh2">可兑换积分</div>
        </li>
        <li @click="$router.push({ name: 'integralAddress' })" class="shdz">
          <p>收货地址</p>
          <div class="shdz1">
            {{ defaultAddress.receiveGoodsPerson }}&nbsp;&nbsp;&nbsp;{{
              defaultAddress.receiveGoodsPhone
            }}
          </div>
          <div class="shdz2">
            <div class="shdz21"></div>
            <div class="shdz22">
              {{
                spliceString(
                  `${defaultAddress.province || ''}-${defaultAddress.city ||
                    ''}-${defaultAddress.area || ''}-${defaultAddress.address ||
                    ''}`
                )
              }}
              <!-- {{userIntegralInfo.province}}-{{userIntegralInfo.city}}-{{userIntegralInfo.area}}-{{spliceString(userIntegralInfo.address)}} -->
            </div>
          </div>
        </li>
        <li v-if="this.$route.name === 'integralGetList'" class="sj1"></li>
        <li v-if="this.$route.name === 'integralOrder'" class="sj2"></li>
        <li v-if="this.$route.name === 'integralExchange'" class="sj3"></li>
        <li v-if="this.$route.name === 'integralAddress'" class="sj4"></li>
      </ul>
      <router-view v-on:childByValue="childByValue"></router-view>
      <div class="integralFooter">
        <div class="integralGetScore">
          <h2>如何获取积分</h2>
          <ul class="getScoreForm noWrap" v-if="userStatus && integralRule">
            <li class="yhzc">
              <h3>用户注册</h3>
              <p>
                {{ userStatus.isRegister ? '您已注册成功' : '您未注册成功' }}
                <span style="color: #CACACA;">已获取</span>
              </p>
              <p>
                用户通过平台成功注册可获得积分奖励<span
                  >+ {{ scoreList.zc }}</span
                >
              </p>
            </li>
            <li class="qd">
              <h3>签到</h3>
              <p>
                <span>{{ date }}</span>
                <span>{{
                  userStatus.isSgin ? '今日已签到' : '今日未签到'
                }}</span>
                <span @click="goSign">
                  <span>去签到</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </p>
              <p>
                用户每日签到，可获得积分奖励<span>+ {{ scoreList.qd }}</span>
              </p>
            </li>
            <!-- <li class="wsgrxx">
              <h3>完善个人信息</h3>
              <p>
                <span>个人信息未完善</span>
                <span></span>
                <span>
                  <span @click="goIndex">去完善</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </p>
              <p>用户完善个人信息，可获得积分奖励<span>+{{integralRule[1].ruleScore}}</span></p>
            </li> -->
            <li class="yxrz">
              <h3>邮箱认证</h3>
              <p>
                <span>{{
                  userStatus.isMail ? '您的邮箱已经认证' : '您的邮箱尚未认证'
                }}</span>
                <span></span>
                <span @click="goMail">
                  <span>去认证</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </p>
              <p>
                用户完成邮箱认证操作，可获得积分奖励<span
                  >+ {{ scoreList.yx }}</span
                >
              </p>
            </li>
            <!--     <li class="tjjy">
              <h3>提交建议</h3>
              <p>
                <span>我们的提升离不开您的支持</span>
                <span></span>
                <span style="margin-left: -10px;" @click="showSugMask">
                  <span>提建议</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </p>
              <p>用户每被采纳一次建议，可获得积分奖励<span>+ {{scoreList.jy}}</span></p>
            </li> -->
          </ul>
          <h2>如何兑换商品</h2>
          <div class="contentStyle">
            下载宁东工业超市 安卓应用/IOS APP <br />
            登入账号，进入个人中心，点击知识社区功能卡中“积分管理”按钮。兑换精美商品
          </div>
        </div>
        <!-- <div class="integralBook" v-if="this.codeBook">
          <h4>如何获取积分</h4>
          <ul class="bookNav">
            <li
              v-for="(item, index) in codeBook"
              :key="index"
              :class="avtiveBookIndex === index?'activeBook':''"
              @click="handleCodeBookChange(item, index)"
            >
              {{item.name}}
            </li>
          </ul>
          <div class="codeValue">
            {{codeValue}}
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { spliceString, getDictDataList } from '@/utils'
export default {
  data () {
    return {
      date: '',
      userIntegralInfo: null,
      shouldUploadSuggestionShow: false,
      sugContent: '',
      sugTypeList: null,
      activeSugTitle: null,
      userStatus: null,
      email: null,
      codeBook: null,
      codeValue: null,
      avtiveBookIndex: 0,
      integralRule: null,
      scoreList: {
        zc: '',
        qd: '',
        yx: '',
        jy: ''
      },
      defaultAddress: {}
    }
  },
  methods: {
    spliceString (str) {
      return spliceString(str, 28)
    },
    goIndex () {
      this.$router.push({ name: 'basicInfo' })
    },
    childByValue (childValue) {
	  if (childValue === '333') {
        this.getDefaultAddress()
	  }
      this.getIntegral()
    },
    goSign () {
      if (this.userStatus.isSgin) {
        this.$message.error('今日已签到')
        return false
      }
      this.$http
        .post(`/front/kc/userInfo/usersgin/save`, {
          signDate: this.userStatus.sysDate
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.getUserStatus()
            this.getIntegral()
            this.$message.success('签到成功')
          }
        })
        .catch(() => {})
    },
    goMail () {
      if (
        this.$store.state.user.email === null ||
        this.$store.state.user.email === ''
      ) {
        this.$message.warning('您尚未填写邮箱，请去个人中心填写邮箱')
      } else {
        this.$http
          .get(`/front/sendMailboxVerification`, {
            params: {
              mail: this.$store.state.user.email
            }
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('认证邮件发送成功，请在邮件内进行确认')
              // } else {
              //   this.$message.error(data.result.msg)
            }
          })
          .catch(() => {
            // this.$message.error(error.response.data.message)
          })
      }
    },
    showSugMask () {
      this.shouldUploadSuggestionShow = true
    },
    hideSugMask () {
      this.shouldUploadSuggestionShow = false
      this.sugContent = ''
      this.activeSugTitle = null
    },
    changeActiveSugTypeList (title) {
      this.activeSugTitle = title
    },
    uploadSug () {
      if (this.sugContent === '') {
        this.$message.warning('请输入您要建议的内容')
      } else if (this.sugContent.toString().length > 5000) {
        this.$message.warning('建议的内容长度不能超过5000位')
      } else {
        this.$http
          .post(`/front/kc/userInfo/useropinion/save`, {
            opinionContent: this.sugContent
          })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('建议提交成功')
            }
            this.hideSugMask()
            // else {
            //   this.$message.error(data.result.msg)
            //   this.hideSugMask()
            // }
          })
          .catch(() => {
            // this.$message.error(error.response.data.message)
            this.hideSugMask()
          })
      }
    },
    jumpToMy () {
      this.$router.push({ name: 'basicInfo' })
    },
    getToday () {
      var nowYear = new Date().getFullYear().toString()
      var nowMonth = (new Date().getMonth() + 1).toString()
      var nowDay = new Date().getDate().toString()
      function timeAdd0 (str) {
        if (str.length <= 1) {
          str = '0' + str
        }
        return str
      }
      nowYear = timeAdd0(nowYear)
      nowMonth = timeAdd0(nowMonth)
      nowDay = timeAdd0(nowDay)
      this.date = nowYear + '-' + nowMonth + '-' + nowDay
    },
    getIntegral () {
      this.$request
        .get(`/front/train/forum/integralOrder/myUserPoint`)
        .then((data) => {
          this.userIntegralInfo = data
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    getDefaultAddress () {
      this.$request
        .get(
          `/front/consumer/user/address/userAddressList`
        )
        .then((data) => {
          if (data && data.length) {
            let defaultAddress = data.find((item) => {
              return item.defaultAddress
            })
            if (!defaultAddress) {
              defaultAddress = data[0]
            }
            this.defaultAddress = defaultAddress || {}
          }
        })
    },
    getUserStatus () {
      this.$http
        .get(`/front/train/forum/integralOrder/isGetIntegral`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$store.dispatch('setUserStatus', data.data)
            this.userStatus = data.data
          }
        })
        .catch(() => {})
    },
    getUserInfo () {
      // this.email = this.$store.state.user.email
      // this.$http.get(`${window.SITE_CONFIG['baseURL']}/sys/user/info`)
      //   .then(data => {
      //     if (!data.result.user.customerId) {
      //       this.$router.push({ name: 'userGuide' })
      //       return false
      //     }
      //     // console.log(data.result.user.email)
      //     this.email = data.result.user.email
      //   })
      //   .catch(error => {
      //     this.$message.error(error.response.data.message)
      //   })
    },
    getSugType () {
      this.$http
        .post(`/front/kc/userInfo/useropinion/useropiniontitle`, {
          page: 1,
          limit: 999
        })
        .then(({ data }) => {
          console.log(data, 'getSugType')
          this.sugTypeList = data.data.data || []
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    getIntegralBook () {
      this.codeBook = getDictDataList('1.如何获取积分?')
      // this.$http.get(`${window.SITE_CONFIG['baseURL']}/sys/dict/findDictByCode`,
      //   {
      //     params: {
      //       code: 'baodian'
      //     }
      //   })
      //   .then(data => {
      //     this.codeBook = data.result.data
      //     this.codeValue = data.result.data[0].value
      //   })
      //   .catch(error => {
      //     this.$message.error(error.response.data.message)
      //   })
    },
    handleCodeBookChange (item, index) {
      this.avtiveBookIndex = index
      this.codeValue = item.value
    },
    getIntegralRule () {
      this.$http
        .post(`/front/train/forum/integralRule/list`, {
          page: 1,
          limit: 10
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.integralRule = data.data.data || []
            // console.log(this.integralRule)
            data.data.data.map((item) => {
              if (item.ruleCode === '1') {
                this.scoreList.zc = item.ruleScore
              } else if (item.ruleCode === '6') {
                this.scoreList.qd = item.ruleScore
              } else if (item.ruleCode === '3') {
                this.scoreList.yx = item.ruleScore
              } else if (item.ruleCode === '7') {
                this.scoreList.jy = item.ruleScore
              }
            })
          }
        })
        .catch(() => {})
    }
  },
  mounted () {
    // this.getToday()
    this.getIntegral()
    // this.getSugType()
    this.getUserStatus()
    this.getUserInfo()
    this.getIntegralBook()
    this.getIntegralRule()
    this.getDefaultAddress()
  }
}
</script>

<style scoped lang="scss">
/* 积分管理整体版心 */
.integralArea {
  width: 1190px;
  margin: 0 auto;
}
/* 提建议蒙版 */
.uploadSuggestion {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  user-select: none;
  padding-top: 180px;
}
.sugArea {
  max-height: 553px;
  width: 530px;
  height: 355px;
  background: #ffffff;
  margin: 0 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.sugTitle {
  display: flex;
  height: 54px;
  line-height: 62px;
  color: #333333;
  font-size: 16px;
  text-indent: 32px;
}
.sugTitle h3 {
  flex: 1;
}
.cancelIcon {
  width: 54px;
  height: 54px;
  cursor: pointer;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAIAAADZrBkAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDA3OEFGQjA5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDA3OEFGQjE5RTFFMTFFOThCRUQ4MjIyNTQxMjc0QTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpEMDc4QUZBRTlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpEMDc4QUZBRjlFMUUxMUU5OEJFRDgyMjI1NDEyNzRBMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppgy6CQAAAE4SURBVHjajNNNi4JAGAfwTT1Ivp0k0q8hXqKO5iU6+GHNIAg8aVJQJy950RQvQgQFSu4jRts64+z+D8Mjzo9xfGYGruvGcTybzRRF+forx+PxdDrpuk4bhnG9Xs/n82g0EgSBYPb7ve/7ZVmyLEtNp1OGYaqqWq1Wl8uFYIIggEKSJE3TBnVdJ0niOA5I8KZpol/7aRaLxXA4bBg8EyRqoH6xPok1vxgqsyzDmi77lBRFPZ9PrMGwVtq23RpoyXK57BgIhf7rPM9bA7nf70VRoHO6qx0Oh91uBwXP84/Ho93nfD5XVbWXvY0oirAfWGe9XmPlD+sYjuOghuOKlS+GNW2wsmEE0ydpy7I8zyOY9pUsy1EUgYRxPB7Tk8kE7gLBoLJpTxiG2+32drvV/0iappvNBhr7LcAACe08BFMfHcMAAAAASUVORK5CYII=)
    no-repeat 20px 20px;
  background-size: 14px 14px;
}
.sugTypeChoose {
  display: flex;
  margin-top: 18px;
  padding: 32px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sugTypeChoose li {
  padding: 0 28px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  border: 1px solid #aaaaaa;
  color: #333333;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.sugTypeChoose .activeSug {
  border: 1px solid #1d65a8;
  color: #1d65a8;
}
.sugContent {
  display: block;
  box-sizing: border-box;
  width: 465px;
  height: 165px;
  min-height: 215px;
  border: 1px solid #eeeeee;
  resize: none;
  margin: 0 auto;
  padding: 10px;
  overflow: visible;
}
.sugButton {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  margin-top: 35px;
}
.sugCancel {
  flex: 1;
  box-sizing: border-box;
  color: #1d65a8;
  border: 1px solid #1d65a8;
  cursor: pointer;
}
.sugConfirm {
  flex: 1;
  color: #ffffff;
  background: #1d65a8;
  cursor: pointer;
}
/* 积分管理整体面包屑 */
.integralBreadcrumb {
  display: flex;
  height: 20px;
  line-height: 20px;
  margin: 20px 0;
}
.integralBreadcrumb div:nth-of-type(1) {
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(1):hover {
  font-weight: bold;
  color: #1d65a8;
}
.integralBreadcrumb div:nth-of-type(2) {
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(3) {
  font-weight: normal;
  font-size: 14px;
  color: #1d65a8;
  user-select: none;
}
/* 积分管理整体导航栏 */
.integralNav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}
.integralNav li {
  width: 283px;
  height: 190px;
  color: white;
  user-select: none;
  cursor: pointer;
}
.integralNav li p {
  margin-top: 33px;
  font-size: 16px;
  line-height: 22px;
}
.wdjf {
  background: url('~@/assets/img/myIntegral.png') no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 14px 10px 0 rgba(0, 0, 0, 0.1);
}
.wdjf1 {
  line-height: 56px;
  height: 56px;
  font-size: 40px;
  margin-top: 20px;
}
.wdjf2 {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  margin-top: 6px;
}
.wdjfdd {
  background: url('~@/assets/img/myIntegralList.png') no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 14px 10px 0 rgba(0, 0, 0, 0.1);
}
.wdjfdd1 {
  line-height: 56px;
  height: 56px;
  font-size: 40px;
  margin-top: 20px;
}
.wdjfdd2 {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  margin-top: 6px;
  display: flex;
}
.wdjfdd21 {
  flex: 1;
  padding-left: 22px;
}
.wdjfdd22 {
  flex: 1;
  padding-right: 22px;
}
.jfdh {
  background: url('~@/assets/img/myIntegralShop.png') no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 14px 10px 0 rgba(0, 0, 0, 0.1);
}
.jfdh1 {
  line-height: 56px;
  height: 56px;
  font-size: 40px;
  margin-top: 20px;
}
.jfdh2 {
  line-height: 20px;
  height: 20px;
  margin-top: 6px;
  font-size: 14px;
}
.shdz {
  background: url('~@/assets/img/myInteralPosition.png') no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 14px 10px 0 rgba(0, 0, 0, 0.1);
}
.shdz1 {
  line-height: 32px;
  height: 32px;
  font-size: 23px;
  margin-top: 22px;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
}
.shdz2 {
  display: flex;
  margin-top: 7px;
}
.shdz21 {
  width: 47px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAUtJREFUKBVtkT1KA0EcxXejIggqRK1i6wGURImdWkha7YKgpVZaapHcQo8gYlIEjLVEkxxALCwULGNusB8w/t46E3aXLLyd9/WfnUk8L/WEYXgK3sDYos96lqr8U2PMahAEXfBIYQc9L8C35YFn9NpkEOOJ8MIZhItgyWmycw0lGlIHbQlKRXgHfFp05ClDt8CJx3QPVGSyPoArcT3wS3mWl+GvMkfsojPPscNX0ky95ClTh+5vARL6vh/QMcBPdR2VZ9RRt4B4j6JoFyMGA/iNa8Kv8YbK4FV1Pcghn+2qxA7LfPYe/S2Iy1OmThzHNXHd44XB/UTwopT8D06T7dHpOa2BTfBBcWFiWiJPGdjKZOzSwLzLmAi8W7Jm3tcxZgj7nPPYhfAjvAHZrPMyK0GJy+l33xAsX8+U8kKXp/gjwA/y+VTN7ivCtPAP0xtWWbfOr70AAAAASUVORK5CYII=)
    no-repeat 25px 5px;
}
.shdz22 {
  flex: 1;
  padding-right: 36px;
  text-align: left;
  line-height: 24px;
  font-size: 14px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.integralNav .sj1 {
  width: 47px;
  height: 17px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 47px 17px;
  position: absolute;
  top: 190px;
  left: 114px;
}
.integralNav .sj2 {
  width: 47px;
  height: 17px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 47px 17px;
  position: absolute;
  top: 190px;
  left: 416.8px;
}
.integralNav .sj3 {
  width: 47px;
  height: 17px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 47px 17px;
  position: absolute;
  top: 190px;
  left: 719.6px;
}
.integralNav .sj4 {
  width: 47px;
  height: 17px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 47px 17px;
  position: absolute;
  top: 190px;
  left: 1022.4px;
}
/* 积分管理整体脚部 */
/* 如何获取积分部分 */
.integralGetScore h2 {
  margin-top: 40px;
  margin-bottom: 20px;
  line-height: 37px;
  font-size: 26px;
  color: #262626;
}
.getScoreForm {
  background: white;
  width: 1190px;
  height: 332px;
  user-select: none;
  position: relative;
  margin-bottom: 40px;
  p {
    margin: 0;
  }
}
.noWrap {
  height: unset;
  .yhzc {
    height: 165px;
    h3 {
      margin-bottom: 28px;
    }
    p {
      &:nth-of-type(1) {
        margin-bottom: 10px;
      }
      &:nth-of-type(2) {
        margin-bottom: 12px;
      }
    }
  }
  > li {
    border-bottom: 0;
  }
}
/* 用户注册 */
.yhzc {
  width: 351px;
  height: 332px;
  padding: 0 71px;
  padding-top: 26px;
  border-right: 1px solid #eeeeee;
}
.yhzc:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.yhzc h3 {
  height: 26.7px;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  background-size: 27px 26.5px;
  text-indent: 41.5px;
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin: 0;
  margin-bottom: 34px;
}
.yhzc p:nth-of-type(1) {
  color: #1d65a8;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 23px;
}
.yhzc p:nth-of-type(2) {
  color: #333333;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 43px;
}
.yhzc p:nth-of-type(3) {
  display: inline-block;
  line-height: 16px;
  font-size: 16px;
  color: #1d65a8;
  cursor: pointer;
}
.yhzc span {
  padding-left: 6px;
}
/* 签到 */
.qd {
  width: 418px;
  height: 165px;
  padding: 30px 54px;
  border-right: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  position: absolute;
  top: 0;
  left: 352px;
}
.qd:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.qd h3 {
  height: 24px;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  background-size: 24px 24px;
  text-indent: 38px;
  line-height: 24px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin: 0;
  margin-bottom: 18px;
}
.qd p {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #333333;
}
.qd p:nth-of-type(1) span:nth-of-type(2) {
  display: inline-block;
  width: 148px;
  text-indent: 16px;
}
.qd p:nth-of-type(1) span:nth-of-type(3) {
  color: #1d65a8;
  cursor: pointer;
}
/* 完善个人信息 */
.wsgrxx {
  width: 418px;
  height: 165px;
  padding: 30px 54px;
  border-bottom: 1px solid #eeeeee;
  position: absolute;
  top: 0;
  left: 771px;
}
.wsgrxx:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.wsgrxx h3 {
  height: 24px;
  background: url(data:image/png;base64,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)
    no-repeat 0 0;
  background-size: 28px 20px;
  text-indent: 38px;
  line-height: 20px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin: 0;
  margin-bottom: 18px;
}
.wsgrxx p {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  margin: 0;
  color: #333333;
}
.wsgrxx p:nth-of-type(1) span:nth-of-type(2) {
  display: inline-block;
  width: 120px;
  text-indent: 16px;
}
.wsgrxx p:nth-of-type(1) span:nth-of-type(3) {
  color: #1d65a8;
  cursor: pointer;
}
/* 邮箱认证 */
.yxrz {
  width: 418px;
  height: 165px;
  padding: 30px 54px;
  border-bottom: 1px solid #eeeeee;
  position: absolute;
  top: 0;
  left: 771px;
}
.yxrz:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.yxrz h3 {
  height: 24px;
  background: url(data:image/png;base64,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)
    no-repeat 0 2px;
  background-size: 24px 19px;
  text-indent: 38px;
  line-height: 24px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin: 0;
  margin-bottom: 18px;
}
.yxrz p {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  margin: 0;
  color: #333333;
}
.yxrz p:nth-of-type(1) span:nth-of-type(2) {
  display: inline-block;
  width: 98px;
  text-indent: 16px;
}
.yxrz p:nth-of-type(1) span:nth-of-type(3) {
  color: #1d65a8;
  cursor: pointer;
}
.yxrz p:nth-of-type(2) {
  white-space: nowrap;
}
/* 提交建议 */
.tjjy {
  width: 418px;
  height: 166px;
  padding: 30px 54px;
  border-right: 1px solid #eeeeee;
  position: absolute;
  top: 166px;
  left: 352px;
  /* width: 418px;
  height: 166px;
  padding: 30px 54px;
  position: absolute;
  top: 166px;
  left: 771px; */
}
.tjjy:hover {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
}
.tjjy h3 {
  height: 24px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAvCAIAAAAXcr/4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODVCOTU4NTVCMUUyMTFFOUI2RUJCREQ0QzE4REI0MjUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODVCOTU4NTZCMUUyMTFFOUI2RUJCREQ0QzE4REI0MjUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NUI5NTg1M0IxRTIxMUU5QjZFQkJERDRDMThEQjQyNSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NUI5NTg1NEIxRTIxMUU5QjZFQkJERDRDMThEQjQyNSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuaglT8AAAOTSURBVHjaYvz//z/DAIHVJ5/0b7+tKMrNiOyIT9//PP/wg3a2yglzcrIxQ9hdm29O2nkHwmaBUFvOP+/ecuveq6+0C5hYW/nWMB0g4/ff/0VLLq4//RQibqUmDHJE64Yb0/fcpWnIl/qo53uoABkfv/9OmXX2+O23EPEgU+neGH2WY7ffzth7j3bWszAzdUToRFjKAtlP3n2PnXb69ovPEKk8D9UyHzWQmrn7H9AuCoApYEaykbO2GJB96dHH+BmnX3/6ieYyEPfSow80coEQD9vCTFNDeQEge8+VV5nzzn3/9RfI5uFgmZlsbK8pAlfJRKPsICvMtbHICuKChYceJs86A3GBpADHukIriAuWHHn04uNPRO6gLtCW4V+SbSrKyw5kN6+/PhOW5rSk+YBhA3QHPIue1hGjiSNMlYWWZJlxszP//PMvf+EFYOaHiNtpis5KNgLGxZ9//0uWXFpz6gki8VLXBSK87LNSjIAueP/1d+LMM2fuvYOIA9NgZ6QuMxPj159/U+ecPXT9NUoOoq4jfIwkgbHw4etv/96jwKIPrZB49eknMIteffIRPRtT1xEKItxAElj2QFzAxsLUE60HLJGA7Lsvv0ZPPfXk3TcsZQl1HXH31RcgaashIsrH/vvPv1mpxlaqwkCR0/feJ8088/7rL+wFGnUdsebkkxw3ZWlBzqMNjv/+/QcmQ6Dg9osvchdc+PH7Ly5dTNR1BLAwiJx88vaLL1xszEAX/PrzD5gP0+eew+MCmmRRYGpwaj2kI8vHx8EKdM2rT4QLQ5oUVsDK6PKjj8SrZ2IYBABLSDAxMaqK8wBJ4k15+Obbt59/qOmIzSXW+nL8JJny+ccf28YDbz7/JM8RTJjBAKl4SAK8HCzAoppqIQHM3F5dRyxUhZgYSYiO608/A2OEmtEBDNUt557TM2EOitwx6ohRRxCRO7jZWYwUBUjKokQ1NV5+xdqiweIIRkbGHRW2iqJcNKjVGJzbDt16/plwdAArwD9//9EizP/9///3339io8Oz84ieHD/VowPYzsDVtsDiCGAr6NTdd6NZdNQRo44YdQTMEYzULpTIcYSiGPdA2Q2sKcX5QaM2TGZKggPlCHBdDQ6JYm81Pk5W+ruAlZmpNlATGh2SAhwzk41ESO9rUAKAHfb+WH0taT5o+wEykvruy69Fhx+ef/DhGS0H2BlAg1pshvICUdZyMkKccEGAAAMAvWFjP2uCYZEAAAAASUVORK5CYII=)
    no-repeat 0 0;
  background-size: 22px 23.5px;
  text-indent: 38px;
  line-height: 23px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  margin: 0;
  margin-bottom: 18px;
}
.tjjy p {
  margin: 0;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #333333;
}
.tjjy p:nth-of-type(1) span:nth-of-type(2) {
  display: inline-block;
  width: 46px;
  text-indent: 16px;
}
.tjjy p:nth-of-type(1) span:nth-of-type(3) {
  color: #1d65a8;
  cursor: pointer;
}
.tjjy p:nth-of-type(2) {
  white-space: nowrap;
}
/* 积分宝典 */
.integralBook h4 {
  height: 26px;
  line-height: 26px;
  font-size: 26px;
  margin-top: 46px;
  margin-bottom: 25px;
  color: #333333;
}
.bookNav {
  height: 82px;
  line-height: 82px;
  background: #ffffff;
  display: flex;
  border-bottom: 1px solid #eeeeee;
}
.bookNav li {
  padding: 0 30px;
  user-select: none;
  cursor: pointer;
  font-size: 16px;
}
.activeBook {
  color: #1d65a8;
  font-weight: bold;
}
.codeValue {
  white-space: pre-line;
  text-indent: 0;
  background: #ffffff;
  line-height: 30px;
  font-size: 16px;
  padding: 0 40px;
  padding-bottom: 30px;
}
.contentStyle {
  padding: 24px;
  line-height: 34px;
  font-size: 16px;
  color: #333333;
  background: #fff;
}
</style>
